import { render, staticRenderFns } from "./AccessTab.vue?vue&type=template&id=6a38de66&scoped=true&"
import script from "./AccessTab.vue?vue&type=script&lang=js&"
export * from "./AccessTab.vue?vue&type=script&lang=js&"
import style0 from "./AccessTab.vue?vue&type=style&index=0&id=6a38de66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38de66",
  null
  
)

export default component.exports